import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { SZZA001AService } from 'sg-api';
import { map, timeout, catchError } from 'rxjs/operators';
import { ApiCommonService } from '../services/api-common.service';
import { Szza001aRequest, Szza001aResponse } from 'sg-api';
import { SHARED_LIB_CONFIG } from '../config/shared-lib-config.token';
import { SharedLibConfig } from '../config/shared-lib-config';
@Injectable({
  providedIn: 'root'
})
export class UsedSzza001aService {
  /** 住所情報取得のSubject */
  // private _zyuusho$: BehaviorSubject<Array<AddressSearchInfoToZipCodeDto>> = new BehaviorSubject<Array<AddressSearchInfoToZipCodeDto>>([]);

  /**
   * 住所情報取得のobservable提供
   *
   * @readonly
   * @memberof UsedSzza001aService
   */
  // get contractorValueChanges(): Observable<Array<AddressSearchInfoToZipCodeDto>> {
  //   return this._zyuusho$.asObservable();
  // }

  /**
   * コンストラクタ
   * @param {SZME045AService} sZME045AService
   * @param {ApiCommonService} apiCommonService
   */
  constructor(private sZZA001AService: SZZA001AService, private apiCommonService: ApiCommonService, @Inject(SHARED_LIB_CONFIG) private sharedLibConfig: SharedLibConfig) {
    // NOTE:画面起動時に情報を表示する場合、HTTPによるデータの取得よりも前に画面生成処理が動作してしまうため、
    // 初期値を設定しておく必要がある
    // this._zyuusho$.next(this.createInitializeData());
  }

  /**
   * Subjectの現在値を取得
   *
   * @return {*}  {Array<Szme045aResponseClaimBasicInf03Dto>}
   * @memberof UsedSzza001aService
   */
  // public getCurrentValue(): Array<AddressSearchInfoToZipCodeDto> {
  //   return this._zyuusho$.getValue();
  // }

  /**
   *お客さま番号での請求基本情報取得API呼び出し
   *
   * @param {*} value
   * @memberof UsedSzza001aService
   */
  searchZyuushoCode(postno: string): Observable<Szza001aResponse> {
    // リクエスト情報生成
    let request: Szza001aRequest = {
      zipCode: postno,
    };
    return this.sZZA001AService.a10RSZZA001APost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          return response.body;
        }),
        timeout(Number(this.sharedLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'sys', 'SZZA001A');
          return throwError(err.message);
        }));
  }

  /**
   * Array<AddressSearchInfoToZipCodeDto>の初期表示値を作成
   *
   * @return {*}  {Array<AddressSearchInfoToZipCodeDto>}
   * @memberof UsedSzza001aService
   */
  // createInitializeData(): Array<AddressSearchInfoToZipCodeDto> {
  //   return [{
  //     addressCode: '',
  //     prefecturesName: '',
  //     cityName: '',
  //     townAreaName: '',
  //     ooazaName: '',
  //     prefecturesNameKana: '',
  //     cityNameKana: '',
  //     townAreaNameKana: '',
  //     ooazaNameKana: '',
  //   }];
  // }
}

